import React, { Fragment } from 'react';
import Select from 'react-select';
import { get, merge } from 'lodash';
import { Field } from 'formik';
import { Form } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import HHInput from './hhInput';
import ErrorMessage from './errorMessage';

const HHLocationSelect = props => {
  const {
    translate,
    field,
    form: { setFieldValue, touched, errors },
    otherProps = {}
  } = props;
  const hasError = !!(touched[field.name] && errors[field.name]);

  const address = get(field, 'value.value.address');
  const coordinates = get(field, 'value.value.coordinates');
  const hasValue = !!address && !!coordinates;

  return (
    <Fragment>
      <Form.Field style={{ width: '100%' }}>
        <Select.Async
          className='form-basicInfo'
          value={field.value}
          onChange={selectedOption => {
            const defaultValue = {
              value: {
                address: {
                  addressLine: '',
                  addressLine2: '',
                  locality: '',
                  adminDistrict: '',
                  adminDistrict2: '',
                  postalCode: '',
                  countryRegion: ''
                }
              },
              coordinates: []
            };
            const mergedValue = merge(defaultValue, selectedOption);

            setFieldValue(field.name, mergedValue);
          }}
          {...otherProps}
        />
      </Form.Field>

      {hasValue && (
        <Fragment>
          <Form.Field>
            <label htmlFor='name'>Address line 1</label>
            <Field
              name='location.value.address.addressLine'
              component={HHInput}
              otherProps={{
                type: 'text',
                className: 'ui input form-basicInfo',
                maxLength: 64,
                placeholder: translate('common.address1')
              }}
            />
          </Form.Field>

          <Form.Field>
            <label htmlFor='name'>Address line 2</label>
            <Field
              name='location.value.address.addressLine2'
              component={HHInput}
              otherProps={{
                type: 'text',
                className: 'ui input form-basicInfo',
                maxLength: 64,
                placeholder: translate('common.address2')
              }}
            />
          </Form.Field>

          <Form.Field>
            <label htmlFor='name'>City</label>
            <Field
              name='location.value.address.locality'
              component={HHInput}
              otherProps={{
                type: 'text',
                className: 'ui input form-basicInfo',
                maxLength: 64,
                placeholder: translate('common.city')
              }}
            />
          </Form.Field>

          <Form.Field>
            <label htmlFor='name'>State/Province</label>
            <Field
              name='location.value.address.adminDistrict'
              component={HHInput}
              otherProps={{
                type: 'text',
                className: 'ui input form-basicInfo',
                maxLength: 64,
                placeholder: translate('common.province')
              }}
            />
          </Form.Field>
          <Form.Field>
            <label htmlFor='name'>Postal Code</label>
            <Field
              name='location.value.address.postalCode'
              component={HHInput}
              otherProps={{
                type: 'text',
                className: 'ui input form-basicInfo',
                maxLength: 64,
                placeholder: translate('common.postalCode')
              }}
            />
          </Form.Field>

          <Form.Field>
            <label htmlFor='name'>Country</label>
            <Field
              name='location.value.address.countryRegion'
              component={HHInput}
              otherProps={{
                type: 'text',
                className: 'ui input form-basicInfo',
                maxLength: 64,
                placeholder: translate('common.country')
              }}
            />
          </Form.Field>
        </Fragment>
      )}

      {hasError && <ErrorMessage error={errors[field.name]} />}
    </Fragment>
  );
};

export default withLocalize(HHLocationSelect);



// WEBPACK FOOTER //
// ./src/components/forms/fields/hhLocationSelect.js